export default __webpack_public_path__ + "static/media/amcase.2ddd1324.svg";